var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.99998 3.33334L8.82498 4.50834L13.475 9.16668H3.33331V10.8333H13.475L8.82498 15.4917L9.99998 16.6667L16.6666 10L9.99998 3.33334Z"}));
}

ArrowForward.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
